export default "__VITE_ASSET__ac02d539__"